/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Image_Invalid_TypeInputs */



/**
* | output |
* | --- |
* | "Image must be webp, png, or jpeg." |
*
* @param {Promo_Image_Invalid_TypeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_image_invalid_type = /** @type {((inputs?: Promo_Image_Invalid_TypeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Image_Invalid_TypeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'image doit être au format webp, png ou jpeg.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La imagen debe ser webp, png o jpeg.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("A imagem deve ser webp, png ou jpeg.")
	if (locale === "it") return /** @type {LocalizedString} */ ("L'immagine deve essere webp, png o jpeg.")
	return /** @type {LocalizedString} */ ("Image must be webp, png, or jpeg.")
});